import { HttpClient, RequestParams } from "../../utils/api/http-client";
import {
    IAddOrderProductRequest,
    IUpdateOrderProductRequest,
    IRemoveOrderProductRequest,
    IOrderProductResponse,
    IOrderProductBulkResponse,
} from "../../models/order-product/types";

class OrderProductService<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;

    constructor(http: HttpClient<SecurityDataType>) {
        this.http = http;
    }

    /**
     * Add multiple products from the same store to an order
     * @param orderId - ID of the order
     * @param data - Store ID and array of products to add
     */
    addProducts = (
        orderId: number,
        data: IAddOrderProductRequest,
        params?: RequestParams
    ) =>
        this.http.request<IOrderProductBulkResponse>({
            path: `/admin/order/${orderId}/product`,
            method: "POST",
            body: data,
            ...params,
        });

    /**
     * Update an existing product in an order
     * @param data - Product order ID and fields to update
     */
    updateProduct = (
        data: IUpdateOrderProductRequest,
        params?: RequestParams
    ) =>
        this.http.request<IOrderProductResponse>({
            path: `/admin/order/product`,
            method: "PUT",
            body: data,
            ...params,
        });

    /**
     * Remove a product from an order
     * Note: Inventory is NOT returned when removing
     * @param data - Product order ID to remove
     */
    removeProduct = (
        data: IRemoveOrderProductRequest,
        params?: RequestParams
    ) =>
        this.http.request<{ success: boolean; message: string }>({
            path: `/admin/order/product`,
            method: "DELETE",
            query: data,
            ...params,
        });
}

export default OrderProductService;
